import { useEffect, useState } from "react";
import ProductPlacementManager from "@/pages/admin/components/ProductPlacementManager";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function AdminDeals() {
  const { settings, updateSettings } = useSiteSettings();
  const [heroImageUrl, setHeroImageUrl] = useState(settings.dealsHeroImageUrl);
  const [homeDescription, setHomeDescription] = useState(settings.homeDealsDescription);

  useEffect(() => {
    setHeroImageUrl(settings.dealsHeroImageUrl);
  }, [settings.dealsHeroImageUrl]);

  useEffect(() => {
    setHomeDescription(settings.homeDealsDescription);
  }, [settings.homeDealsDescription]);

  const saveHeroImage = () => {
    const nextValue = heroImageUrl.trim() || settings.dealsHeroImageUrl;
    setHeroImageUrl(nextValue);
    updateSettings({ dealsHeroImageUrl: nextValue });
  };

  const saveHomeDescription = () => {
    const nextValue = homeDescription.trim();
    setHomeDescription(nextValue);
    updateSettings({ homeDealsDescription: nextValue });
  };

  return (
    <ProductPlacementManager
      title="Ofertas do Dia"
      subtitle="Esta tela é uma extensão do cadastro do produto"
      flag="showInDailyDeals"
      icon="ri-fire-line"
      enabledLabel="Oferta do Dia"
      enabledDescription="Ative ou desative por aqui quais produtos do cadastro ficam visíveis na área de Ofertas do Dia. Para criar um novo item, use o cadastro de produtos."
      emptyLabel="Nenhum produto encontrado para este filtro"
      layout="cards"
      topContent={
        <div className="mb-6 space-y-6">
          <div className="rounded-3xl border border-gray-100 bg-white p-5 md:p-6">
            <div className="flex items-start justify-between gap-4 flex-wrap mb-5">
              <div>
                <h2 className="text-lg font-black text-gray-900 flex items-center gap-2">
                  <i className="ri-image-edit-line text-orange-500"></i>
                  Hero da página /ofertas
                </h2>
                <p className="text-sm text-gray-500 mt-1">
                  Altere aqui a imagem principal da Hero da página de Ofertas. A pré-visualização abaixo é atualizada imediatamente.
                </p>
              </div>
              <button
                onClick={saveHeroImage}
                className="px-4 py-2.5 rounded-xl bg-orange-500 text-white text-sm font-bold hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-save-line mr-1.5"></i>Salvar imagem
              </button>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-[360px_1fr] gap-5 items-start">
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">
                  URL da imagem da Hero
                </label>
                <input
                  value={heroImageUrl}
                  onChange={(e) => setHeroImageUrl(e.target.value)}
                  placeholder="https://..."
                  className="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
                />
                <button
                  onClick={saveHeroImage}
                  className="mt-3 w-full px-4 py-3 rounded-2xl border border-orange-200 bg-orange-50 text-orange-600 text-sm font-bold hover:bg-orange-100 transition-colors cursor-pointer"
                >
                  Aplicar na pré-visualização
                </button>
              </div>

              <div>
                <span className="block text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">
                  Pré-visualização ativa
                </span>
                <div className="relative overflow-hidden rounded-3xl min-h-[248px] md:min-h-[288px] border border-gray-100">
                  <img
                    src={heroImageUrl.trim() || settings.dealsHeroImageUrl}
                    alt="Pré-visualização da hero de ofertas"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/70 to-transparent"></div>
                  <div className="relative z-10 flex min-h-[248px] md:min-h-[288px] items-center p-6 md:p-8">
                    <div className="max-w-xl">
                      <div className="flex items-center gap-2 mb-3">
                        <span className="bg-red-500 text-white text-xs font-black px-3 py-1 rounded-full flex items-center gap-1">
                          <i className="ri-flashlight-fill"></i>
                          AO VIVO
                        </span>
                        <span className="text-white/70 text-sm">Prévia da página de ofertas</span>
                      </div>
                      <h3 className="text-3xl font-black text-white mb-3 leading-tight">Ofertas do Dia</h3>
                      <p className="text-white/80 text-sm">
                        Esta é a pré-visualização da Hero que será exibida na página pública de ofertas.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-3xl border border-gray-100 bg-white p-5 md:p-6">
            <div className="flex items-start justify-between gap-4 flex-wrap mb-4">
              <div>
                <h2 className="text-lg font-black text-gray-900 flex items-center gap-2">
                  <i className="ri-text text-orange-500"></i>
                  Texto abaixo de Ofertas do Dia na Home
                </h2>
                <p className="text-sm text-gray-500 mt-1">
                  O texto salvo aqui será exibido logo abaixo do título da seção Ofertas do Dia em /.
                </p>
              </div>
              <button
                onClick={saveHomeDescription}
                className="px-4 py-2.5 rounded-xl bg-orange-500 text-white text-sm font-bold hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-save-line mr-1.5"></i>Salvar texto
              </button>
            </div>

            <textarea
              value={homeDescription}
              onChange={(e) => setHomeDescription(e.target.value)}
              rows={3}
              className="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm resize-none focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
              placeholder="Digite o texto exibido abaixo do título da seção na Home"
            />
          </div>
        </div>
      }
    />
  );
}
